import React, { useState } from 'react'
import { Check, Lock } from 'lucide-react'

export default function ChapterSelector({ chapters, onSelectionChange, onIsLockedClick }) {
    const [selectedChapters, setSelectedChapters] = useState([])

    const getCheckboxStyle = (isSelected) => {
        if (!isSelected) return 'border-gray-300 bg-white'
        return 'border-blue-500 bg-blue-500'
    }

    const toggleChapter = (chapter,index) => {
        if (chapters.isLocked && index > 1) {
            return onIsLockedClick(chapter)
        }
        setSelectedChapters(prev => {
            const newSelection = prev.includes(chapter?.id)
                ? prev.filter(id => id !== chapter?.id)
                : [...prev, chapter?.id]
            onSelectionChange(newSelection)
            return newSelection
        })
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 py-4">
            {chapters?.data?.map((chapter, index) => (
                <button
                    key={chapter.id}
                    onClick={() => toggleChapter(chapter,index)}
                    className={`
                        flex items-center justify-between p-3 rounded-[10px] border
                        ${selectedChapters.includes(chapter.id)
                            ? 'bg-white text-gray-800 border-blue-600'
                            : 'bg-white text-gray-800 border-gray-200'}`}
                >
                    <div className="flex items-center gap-2">
                        <div
                            className={`flex-shrink-0 w-5 h-5 mt-1 sm:mt-0 border rounded flex items-center justify-center cursor-pointer ${getCheckboxStyle(selectedChapters.includes(chapter.id))}`}>
                            {selectedChapters.includes(chapter.id) ? (
                                <Check size={16} color="white" />
                            ) : <Check className="w-5 h-5 mr-2 opacity-0" />}
                        </div>
                        <div style={{ textAlign: 'left' }}>{chapter.chapter_no} ({chapter.chapter})</div>
                    </div>
                    {(chapters.isLocked && index > 1) || chapter.isLocked ? <Lock className="w-5 h-5" /> : null}
                </button>
            ))}
        </div>
    )
}
